<app-page-header [title]="'Body Types'" [subtitle]="'Manage body types for SampleStudio'"></app-page-header>
<div class="mb-6">
    <div class="flex justify-between mb-2">
        <p-ifta-label>
            <p-iconfield>
                <p-inputicon class="pi pi-search"></p-inputicon>
                <input pInputText id="body_type_search" [(ngModel)]="this.search" (input)="onSearchInputChange()"
                       autocomplete="off"/>
            </p-iconfield>
            <label for="body_type_search">Search body type</label>
        </p-ifta-label>
        <p-button label="Add Body Type" icon="pi pi-plus" (click)="this.openCreateBodyTypeDialog()" isAdmin
                  [hidden]="false"></p-button>
    </div>
    <div class="border border-gray-300 dark:border-gray-700 p-2 dark:p-0 mb-5 rounded-sm">
        <p-table
                [value]="this.bodyTypes"
                [paginator]="true"
                [rows]="this.rows"
                [totalRecords]="this.totalRecords"
                [lazy]="true"
                [first]="this.currentPage * this.rows"
                [loading]="this.loading"
                [rowsPerPageOptions]="[5, 10, 20]"
                (onLazyLoad)="this.onPageChange($event)"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th></th>
                    <th>Name</th>
                    <th>Label</th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-bodyType>
                <tr>
                    <td>
                        <img
                                [src]="bodyType?.icon?.content?.preview?.cloudfrontUrl || 'assets/images/no-image.png'"
                                alt="Brand Logo"
                                class="w-10 h-10 object-cover rounded-sm">
                    </td>
                    <td>{{ bodyType.name }}</td>
                    <td>{{ bodyType.label }}</td>
                    <td>
                        <div class="flex justify-end">
                            <p-button icon="pi pi-eye" text
                                      pTooltip="View body type"
                                      tooltipPosition="left"
                                      routerLink="/body-types/body-type/{{bodyType.id}}"></p-button>

                            <p-button icon="pi pi-pencil" text
                                      isAdmin
                                      pTooltip="Edit body type"
                                      tooltipPosition="left"
                                      (click)="this.editBodyType(bodyType)"></p-button>

                            <p-button icon="pi pi-trash" text
                                      isAdmin
                                      pTooltip="Delete body type"
                                      tooltipPosition="left"
                                      (click)="this.deleteBodyType(bodyType)"
                                      severity="danger"></p-button>
                        </div>

                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
<div class="flex gap-2 mb-6">
    <p-button label="Export all Body Types" icon="pi pi-download" (click)="this.exportBodyTypes()"
              severity="secondary"></p-button>
</div>

<!-- Create Body Type Dialog -->
<app-create-body-type-dialog
        [(visible)]="this.displayCreateBodyTypeDialog"
        (bodyTypeCreated)="this.reloadBodyTypes()"
></app-create-body-type-dialog>

<!-- Update Body Type Dialog -->
<app-update-body-type-dialog
        [(visible)]="this.displayUpdateBodyTypeDialog"
        [bodyType]="this.selectedBodyType"
        (bodyTypeUpdated)="this.reloadBodyTypes()"
></app-update-body-type-dialog>
